import { DriveFolderUpload, Close } from "@mui/icons-material";
import {
  Button,
  Stack,
  Dialog,
  Box,
  Typography,
  IconButton,
  Divider,
  Alert,
} from "@mui/material";
import React from "react";
import { LoadingButton } from "@mui/lab";
import { GlobalContext } from "../../../../../context/GlobalContext";
import TextFieldNew from "../../../../../components/TextFieldNew";

const WhatsCRMAiAction = ({ data, i, buttonDeploy }) => {
  const { hitAxios } = React.useContext(GlobalContext);
  const CON = React.useContext(GlobalContext);

  const [state, setState] = React.useState({
    dialog: false,
    password: "",
  });

  async function installApp() {
    const res = await hitAxios({
      path: "/api/user/install_wacrm_addon",
      post: true,
      admin: false,
      obj: {
        id: i?.id,
        password: state.password,
      },
    });
    if (res.data.success) {
      alert("DONT FORGET TO HIT NPM INSTALL AND RESTART YOUR NODEJS APP");
      setState({ ...state, dialog: false, password: "" }); // Close dialog and reset password
    }
  }

  const handleOpenDialog = () => {
    setState({ ...state, dialog: true });
  };

  const handleCloseDialog = () => {
    setState({ ...state, dialog: false, password: "" });
  };

  return (
    <div>
      {/* Password Dialog */}
      <Dialog
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 10,
            backgroundColor: "rgba(255, 255, 255, 0)",
            backdropFilter: "blur(4px)",
          },
        }}
        onClose={handleCloseDialog}
        open={state.dialog}
      >
        <Box p={2}>
          <Stack direction={"column"} spacing={2}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography fontWeight={"bold"}>
                Install WhatsCRM AI Addon
              </Typography>
              <IconButton onClick={handleCloseDialog}>
                <Close />
              </IconButton>
            </Stack>
            <Divider />

            <TextFieldNew
              value={state.password}
              onChange={(e) => setState({ ...state, password: e.target.value })}
              helperText="Enter admin password to proceed with installation"
              label="WhatsCRM Admin Password"
              type="password"
            />

            <LoadingButton
              loading={CON.data.loading}
              onClick={installApp}
              sx={{ boxShadow: 0, borderRadius: 2 }}
              variant="contained"
              color="success"
              disabled={!state.password.trim()}
            >
              Install Addon
            </LoadingButton>

            {CON.data.snack && (
              <Alert severity={CON.data.snack_success ? "success" : "error"}>
                {CON.data.snack_msg}
              </Alert>
            )}
          </Stack>
        </Box>
      </Dialog>

      {/* Main Button */}
      <Stack direction={"row"} justifyContent={"flex-end"} spacing={2}>
        <Button
          onClick={handleOpenDialog}
          size="small"
          startIcon={<DriveFolderUpload />}
          sx={{
            boxShadow: 0,
            borderRadius: 2,
          }}
          variant="contained"
          color="success"
        >
          {data.uploadAddon}
        </Button>
      </Stack>
    </div>
  );
};

export default WhatsCRMAiAction;
